import type { FunctionComponent } from 'react'
import React from 'react'
import { ButtonLink, TypographyV2 as Typography } from '@which/seatbelt'
import {
  PadlockIcon,
  PadlockOpenIcon,
  SolidPadlockIcon,
} from '@which/seatbelt/src/components/Icons/Miscellaneous'

import classnames from 'classnames'

import { useSubscriptionCostInfo } from '../../hooks/useSubscriptionCostInfo'
import { Link } from '../Link'
import styles from './SinglePadlockCta.module.scss'

export const SinglePadlockCta: FunctionComponent<Props> = ({
  buttonCopy = 'Unlock table',
  displayButtonIcon = true,
  displayStandfirst = true,
  horizontal = false,
  lockedPadlockIcon = true,
  standfirst = 'Get instant access to this and all our scores and recommendations',
  title = 'Sign up to reveal',
  type,
}) => {
  const subscriptionCostInfo = useSubscriptionCostInfo()
  return (
    <div
      className={classnames(styles.ctaWrapper, type === 'desktop' && styles['ctaWrapperDesktop'], {
        [styles.horizontal]: horizontal,
      })}
    >
      <div className={styles.icon}>{lockedPadlockIcon ? <PadlockIcon /> : <PadlockOpenIcon />}</div>
      <div className={styles.ctaContent}>
        <Typography textStyle="sb-text-heading-small">{title}</Typography>
        {displayStandfirst && (
          <Typography textStyle="sb-text-body-small-regular" className={styles.contentWrapper}>
            {standfirst}
          </Typography>
        )}
        <ButtonLink
          appearance="secondary"
          href="https://join.which.co.uk/join/subscribe"
          className={styles.cta}
          data-which-id="nstunlockedprovider-signup-cta"
        >
          {displayButtonIcon && <SolidPadlockIcon width={15} height={15} viewBox="0 0 15 15" />}
          {buttonCopy}
        </ButtonLink>

        <Typography textStyle="sb-text-body-small-regular">
          {subscriptionCostInfo.CTACaptionText}
        </Typography>

        <Typography textStyle="sb-text-body-default-regular">
          <span>Already a member? </span>
          <Link href="/login">Log in</Link>
        </Typography>
      </div>
    </div>
  )
}

type Props = {
  buttonCopy?: string
  displayButtonIcon?: boolean
  displayStandfirst?: boolean
  horizontal?: boolean
  lockedPadlockIcon?: boolean
  standfirst?: string
  title?: string
  type?: string
}
